var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"column":"","align-center":""}},[_c('v-flex',{staticClass:"logout-loading"},[_c('v-progress-circular',{attrs:{"size":"200","indeterminate":"","color":"primary"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }